module.exports = __webpack_public_path__ + "static/media/wsspIcon.cdf8cf47.svg";